<template lang="pug">
extends ./BaseMessage/BaseMessage.pug
block child
  .message-container(:class="baseClass")
    .message-item(v-if="senderType")
      .message-avatar
        .no-image(v-if="!avatar && senderInitials") {{ senderInitials }}
        img(v-else-if="!senderInitials && !avatar"
            :src="photo"
            :alt="avatarAltText")
        img(v-else-if="avatar" 
           :src="avatar" 
           :alt="avatarAltText")
      .message-bubble
        .message-bubble_header
          .message-bubble_name
            i(v-if="senderType === 'customers'",
              :title="channelInfo.title",
              :class="`aiq-ico-conversation-${channel}`")
            i(v-if="senderType === 'agents'",
              :title="channelInfo.title",
              :class="`aiq-ico-conversation-${channel}-white`")
            span {{ senderName }}
          .message-bubble_date
            aiq-timeago(:since="messageDate" :maxTime="maxTime")
        .message-bubble_content(v-html="content")
</template>

<script>
import get from 'lodash/get';

import { getInitials } from '../MessageUtils';
import BaseMessage from './BaseMessage/BaseMessage.vue';

export default {
  extends: BaseMessage,
  name: 'twitterMessage',
  computed: {
    senderInitials() {
      const { first_name, last_name } = get(this.message, 'sender.profile', {
        first_name: '',
        last_name: '',
      });
      return first_name || last_name
        ? getInitials(first_name, last_name)
        : null;
    },

    avatar() {
      return get(this.message, 'sender.profile.image', '');
    },

    senderName() {
      return get(this.message, 'sender_name', '');
    },
  },
};
</script>

<style lang="scss" scoped>
.message-agent {
  .message-bubble {
    overflow: hidden;
  }
}
.asset-container {
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }
}
</style>
